import store from "@/store";

function getUrl() {
  return store.state.user.user.sysType == 1 ? "/outsource" : "/customer";
}

function getParams(query, page) {
  let params = {
    pageNum: page.current,
    pageSize: page.size,
  };
  for (let k of Object.keys(query)) {
    if (query[k]) {
      params[k] = query[k];
    }
  }
  return params;
}

// 供应商相关接口
export default function (axios) {
  return {
    // 获取供应商详情
    getBpoInfo(compId) {
      let url =
        store.state.user.user.sysType == 1
          ? "/outsource/getOutsource"
          : "/customer/getCustomer";
      return axios.get(url, { params: { compId } });
    },
    // 保存虚拟供应商
    saveProvider(params) {
      return axios.post(`${getUrl()}/saveVirtualComp`, params);
    },
    // 发送邀请
    sendInvite(compIds, requestComment) {
      return axios.post(`${getUrl()}/sendInvitation`, {
        compIds,
        reqFlag: store.state.user.user.sysType,
        requestComment,
      });
    },
    // 新  激活邀请
    activatInvite(data) {
      return axios.post("/outsource/activatInvitation", data);
    },
    // 查询合作企业的邀请内容
    getRequestComment(params) {
      return axios.get("/outsource/getRequestComment", { params });
    },

    
    // 供应商列表,按分类划分,权限中用
    ByAttributeList() {
      let url = `${getUrl()}/selectByAttribute`;
      return axios.post(url, {});
    },
    // 供应商搜索
    bpoSearch(query, page) {
      let params = getParams(query, page);
      return axios.post(`${getUrl()}/selectPageAll`, {}, { params });
    },
    // 我邀请的列表
    invitedList(query, page) {
      let params = getParams(query, page);
      params["reqStatus"] = params.status;
      return axios.post(`${getUrl()}/selectInvitedPage`, {}, { params });
    },
    // 我邀请的列表
    invitedListApi(params) {
      return axios.post(`${getUrl()}/selectInvitedPage`, {}, { params });
    },
    // 邀请我的列表
    approvedList(query, page) {
      let params = getParams(query, page);
      params["reqStatus"] = params.status;
      return axios.post(`${getUrl()}/selectApprovedPage`, {}, { params });
    },
    // 邀请我的列表
    approvedListApi(params) {
      return axios.post(`${getUrl()}/selectApprovedPage`, {}, { params });
    },
    // 终止合作
    stopCoop(params, sign) {
      let url =
        sign == 2
          ? "/outsource/cancelCooperation"
          : "/customer/cancelCooperation";
      return axios.post(url, {}, { params });
    },
    // 恢复供应商
    recoverProvider(params, sign) {
      let url =
        sign == 2
          ? "/outsource/resumeCooperation"
          : "/customer/resumeCooperation";
      return axios.post(url, {}, { params });
    },
    // 删除供应商
    removeProvider(compIds) {
      return axios.post(
        `${getUrl()}/deleteVirtualComp`,
        {},
        {
          params: { compIds },
        },
      );
    },
  };
}
